import { combineI18nMessages, defaultMessagesEN, HTML_CODES } from "@duosoftbg/nacid-components";
import validationKeysEN from "./slices/validationKey/validationKeysEN";

const messagesEn = combineI18nMessages(defaultMessagesEN, {
  translation: {
    "t.page.homePage": "Home page",
    "t.page.sitemap": "Sitemap",
    "t.page.sitemap.edit": "Edit sitemap",
    "t.page.homePageCategory.edit": "Home page content - edit",
    "t.page.contacts.edit": "Edit contacts",
    "t.page.serviceDefinitions.edit": "Edit service definitions",
    "t.page.feedback.admin": "Feedback management",
    "t.page.global.message.admin": "Global messages management",
    "t.page.email.templates.admin": "Email templates management",
    "t.page.email.notifications.admin": "Email notifications management",
    "t.page.admin.console": "Admin console",
    "t.page.contacts": "Contacts",
    "t.page.law": "Law",
    "t.page.law.edit": "Law edit",
    "t.page.cache": "Cache clear",
    "t.page.registration": "Registration of user profile",
    "t.page.registration.success": "Successful registration of user profile",
    "t.page.feedback": "Opinions, suggestions, recommendations and problems encountered",
    "t.page.my.account": "My Account",
    "t.page.forgotten.password": "Forgotten password",
    "t.page.forgotten.username": "Forgotten username",
    "t.page.activation.link": "New activation link",
    "t.page.reset.password": "Reset password",
    "t.page.account.activation": "Account activation",
    "t.page.change.email": "Change email",
    "t.page.admin.console.config": "Admin console management",
    "t.homePage.services": "Services",
    "t.homePage.reports": "Reports",
    "t.homePage.law": "Law",
    "t.homePage.registers": "Public registers access",
    "t.homePage.userGuide": "User guide",
    "t.homePageCategory.create.dialog": "Category create",
    "t.homePageCategory.edit.dialog": "Category edit",
    "t.homePageCategoryLink.create.dialog": "Link create",
    "t.homePageCategoryLink.edit.dialog": "Link edit",
    "t.sitemap.group.create.dialog": "Create group",
    "t.sitemap.group.delete.dialog": "Group deleting",
    "t.sitemap.subgroup.delete.dialog": "Subgroup deleting",
    "t.law.file.delete.dialog": "File deleting",
    "t.sitemap.link.delete.dialog": "Link deleting",
    "t.sitemap.group.edit.dialog": "Edit group",
    "t.sitemap.subgroup.create.dialog": "Create subgroup",
    "t.sitemap.subgroup.edit.dialog": "Edit subgroup",
    "t.sitemap.link.create.dialog": "Create link",
    "t.sitemap.link.edit.dialog": "Edit link",
    "t.email.notification.delete.dialog": "Notification deletion",
    "t.email.notification.resend.dialog": "Notification resending",
    "t.email.notification.view.dialog": "Notification view",
    "t.email.template.delete.dialog": "Template deletion",
    "t.email.globalMessage.delete.dialog": "Message deletion",
    "t.email.serviceDefinition.delete.dialog": "Description deletion",
    "t.email.globalMessage.activation.dialog": "Enable/disable message",
    "t.email.template.create.dialog": "Template creation",
    "t.globalMessage.create.dialog": "Message creation",
    "t.globalMessage.edit.dialog": "Message editing",
    "t.email.template.edit.dialog": "Template editing",
    "t.email.template.view.dialog": "Template view",
    "t.global.message.view.dialog": "Message view",
    "t.service.definition.view.dialog": "Definition view",
    "t.service.definition.edit.dialog": "Definition edit",
    "t.service.definition.create.dialog": "Definition create",
    "t.feedback.details.dialog": "Feedback details",
    "t.feedback.text": "Feedback",
    "t.page.groupsAndRoles.admin": "Groups and roles administration",
    "t.tab.groups": "Groups",
    "t.tab.roles": "Roles",
    "t.role.view.dialog": "Role details",
    "t.role.edit.dialog": "Edit role",
    "t.main.details": "Main details",
    "t.logo": "Logo",
    "t.special.actions": "Special actions",
    "t.change.email.dialog": "Change email",
    "t.change.password.dialog": "Change password",
    "t.role.users": "Users with role",
    "t.role.groupUsers": "Users with role because of group membership",
    "t.group.create.dialog": "Create a group",
    "t.group.edit.dialog": "Edit group",
    "t.group.view.dialog": "View group",
    "t.group.roles": "Group roles",
    "t.group.users": "Group users",
    "t.page.users.admin": "Users administration",
    "t.page.user.admin.edit": "Edit user",
    "t.page.user.admin.view": "View user",
    "t.user.roles": "User roles",
    "t.user.groups": "User groups",
    "t.ac.roles": "Roles",
    "t.ac.section.create.dialog": "Section creation",
    "t.ac.section.update.dialog": "Section update",
    "t.ac.section.delete.dialog": "Section deletion",
    "t.ac.page.create.dialog": "Page creation",
    "t.ac.page.update.dialog": "Page update",
    "t.ac.page.delete.dialog": "Page deletion",
    "t.personal.details": "Personal details",
    "t.registration.details": "Registration details",
    "t.account.verification.details": "Account verification",
    "t.representative.details": "Representative",
    "t.contactAddress.details.default": "Default contact address",
    "t.resultReceive.way.default": "Default way of receiving of the notifications",
    "t.resultReceive.way": "Way of receiving of the notifications",
    "t.receiverAddress.details.default": "Default receiver address",
    "t.educationSystemsOverview": "Education Systems Overview",
    "t.qualAssess": "Qualifications Assessment Tool",

    "l.detail.info": "Information",
    "l.detail.regulations": "Regulations",
    "l.detail.address": "Address",
    "l.detail.infoCenter": "Info center",
    "l.detail.telephone": "Telephone",
    "l.detail.fax": "Fax",
    "l.detail.email": "Email",
    "l.detail.website": "Website",
    "l.table.head.id": "Id",
    "l.table.head.service": "Service",
    "l.table.head.section": "Section name",
    "l.table.head.section.en": "Section english name",
    "l.table.head.groupName": "Group name",
    "l.table.head.groupNameEn": "Group english name",
    "l.table.head.position": "Position",
    "l.table.head.pages": "Pages",
    "l.table.head.page": "Page name",
    "l.table.head.page.en": "Page english name",
    "l.table.head.children": "Children page section name",
    "l.table.head.children.en": "Children page section english name",
    "l.table.head.subGroupName": "Subgroup name",
    "l.table.head.subGroupNameEn": "Subgroup english name",
    "l.table.head.subGroups": "Subgroups",
    "l.table.head.groups": "Groups",
    "l.table.head.links": "Links",
    "l.table.head.link": "Link",
    "l.table.head.linkName": "Link name",
    "l.table.head.linkNameEn": "Link english name",
    "l.table.head.person.name": "Name",
    "l.table.head.createdDate": "Created on",
    "l.table.head.updatedDate": "Last updated",
    "l.table.head.type": "Type",
    "l.table.head.isRead": "Is read",
    "l.table.head.sentDate": "Sent on",
    "l.table.head.subject": "Subject",
    "l.table.head.logo": "Logo",
    "l.table.head.file": "File",
    "l.table.head.recipients": "Recipients",
    "l.table.head.status": "Status",
    "l.table.head.name": "Name",
    "l.table.head.settlementName": "Settlement",
    "l.table.head.address": "Address",
    "l.table.head.zipcode": "Zip code",
    "l.table.head.website": "Website",
    "l.table.head.nameEn": "Name (EN)",
    "l.table.head.lastUpdateDate": "Last updated",
    "l.btn.home": "Home",
    "l.btn.create.group": "Create group",
    "l.btn.edit.group": "Edit group",
    "l.btn.create.subgroup": "Create subgroup",
    "l.btn.edit.subgroup": "Edit subgroup",
    "l.btn.edit.contacts": "Edit contacts",
    "l.btn.create.link": "Create link",
    "l.btn.edit.link": "Edit link",
    "l.btn.register": "Create account",
    "l.btn.forgotten.password": "Recover password",
    "l.btn.submit": "Send",
    "l.btn.view.all": "View all",
    "l.btn.attachment.save": "Download attachment file",
    "l.btn.feedback.mark.read": "Mark as read",
    "l.btn.change.email": "Change email",
    "l.btn.change.password": "Change password",
    "l.btn.delete.read": "Delete read",
    "l.btn.create.template": "Create template",
    "l.btn.create.globalMessage": "Create message",
    "l.btn.create.serviceDefinition": "Create service definition",
    "l.btn.save.template": "Save template",
    "l.user.username": "Username",
    "l.user.password": "Password",
    "l.user.confirmPassword": "Repeat password",
    "l.input.sitemap.id": "Id",
    "l.input.sitemap.group.name": "Group name",
    "l.input.sitemap.group.nameEn": "English group name",
    "l.input.sitemap.position": "Position",
    "l.input.sitemap.subgroup.name": "Subgroup name",
    "l.input.sitemap.subgroup.nameEn": "English subgroup name",
    "l.person.name": "Name",
    "l.person.foreignerIdentifierKind": "Identifier kind",
    "l.person.isRepresentative": "The registered user in the portal is representative of company or university",
    "l.person.representative.type": "Representative type",
    "l.person.representative.type.UNIVERSITY_REPRESENTATIVE": "University representative",
    "l.person.representative.type.COMPANY_REPRESENTATIVE": "Company representative",
    "l.university": "University",
    "l.company": "Company",
    "l.eik": "UIC",
    "l.detail.zipCode": "Zip code",
    "l.detail.city": "City",
    "l.feedback": "Feedback",
    "l.input.sitemap.link.name": "Link name",
    "l.input.sitemap.link.nameEn": "English link name",
    "l.input.sitemap.link": "Link",
    "l.input.category.link": "Link",
    "l.input.ac.id": "Id",
    "l.input.ac.section.title": "Section name",
    "l.input.ac.section.title.en": "Section english name",
    "l.input.ac.page.title": "Page name",
    "l.input.ac.page.title.en": "Page english name",
    "l.input.ac.position": "Position",
    "l.input.home.category.position": "Position",
    "l.input.ac.href": "Link",
    "l.searchFilter.recipients": "Recipients",
    "l.searchFilter.status": "Status",
    "l.searchFilter.statusCode": "Status",
    "l.searchFilter.globalMessageType": "Type",
    "l.searchFilter.createdDate": "Created date",
    "l.searchFilter.sentDate": "Sent date",
    "l.searchFilter.nameEn": "Name (EN)",
    "l.searchFilter.subject": "Subject",
    "l.searchFilter.text": "Content",
    "l.searchFilter.textEn": "Content (EN)",
    "l.searchFilter.lastUpdateDate": "Last updated",
    "l.searchFilter.isHtml": "HTML",
    "l.email.notification.sent": "Sent",
    "l.email.notification.notSent": "Not sent",
    "l.email.notification.inSendingProcess": "In sending process",
    "l.email.notification.resent": "Resent",
    "l.email.notification.id": "ID",
    "l.email.notification.subject": "Subject",
    "l.email.notification.recipients": "Recipients",
    "l.email.notification.cc": "CC",
    "l.email.notification.bcc": "BCC",
    "l.email.notification.createdDate": "Date of creation",
    "l.email.notification.sentDate": "Date of sending",
    "l.email.notification.isHtml": "HTML",
    "l.email.notification.replyTo": "Reply to",
    "l.email.notification.comment": "Comment",
    "l.email.notification.skipSending": "Skip sending",
    "l.email.notification.text": "Content",
    "l.email.template.id": "ID",
    "l.email.template.name": "Name",
    "l.globalMessage.name": "Name",
    "l.email.template.nameEn": "Name (EN)",
    "l.globalMessage.nameEn": "Name (EN)",
    "l.globalMessage.text": "Text",
    "l.serviceDefinition.id": "Service",
    "l.serviceDefinition.description": "Description",
    "l.globalMessage.textEn": "Text (EN)",
    "l.email.template.subject": "Subject",
    "l.email.template.text": "Content",
    "l.email.template.createdDate": "Date of creation",
    "l.globalMessage.createdDate": "Date of creation",
    "l.email.template.lastUpdateDate": "Date of last update",
    "l.globalMessage.lastUpdateDate": "Date of last update",
    "l.globalMessage.type": "Type",
    "l.globalMessage.active": "Active",
    "l.email.template.isHtml": "HTML",
    "l.email.template.userCreate": "Creator",
    "l.email.template.userLastUpdate": "Last updated by",
    "l.email.template.params": "Parameters",
    "l.select.user": "Select user",
    "l.select.role": "Select role",
    "l.settlement": "Settlement",
    "l.description": "Description",
    "l.description.en": "English description",
    "l.name": "Name",
    "l.reports.logo": "Reports logo",
    "l.libserv.logo": "Library services logo",
    "l.apostille.logo": "Stamp logo",
    "l.certificates.logo": "Certificates logo",
    "l.academic.recognition.logo": "Academic recognition logo",
    "l.registers.logo": "Registers logo",
    "l.common.services.logo": "Common services logo",
    "l.impact.factor.logo": "Impact factor logo",
    "l.prof.qualification.logo": "Professional qualifications logo",
    "l.logo": "Logo",
    "l.table.head.description": "Description",
    "l.table.head.descriptionEn": "Description(EN)",
    "l.searchFilter.description": "Description",
    "l.searchFilter.username": "Username",
    "l.searchFilter.email": "Email",
    "l.searchFilter.enabled": "Enabled",
    "l.searchFilter.emailVerified": "Email verified",
    "l.table.head.username": "Username",
    "l.table.head.email": "Email",
    "l.table.head.enabled": "Enabled",
    "l.table.head.emailVerified": "Email verified",
    "l.user.enabled": "Enabled",
    "l.user.emailVerified": "Email verified",
    "l.user.email": "Email",
    "l.select.group": "Select group",
    "l.arUniEntryRequest": "File data under Art.19, para.2",
    "l.arUniEntryRequest.list": "My data under Art.19, para.2",
    "l.showInServicesPage": "Show in All services page",
    "l.btn.expandDetails": "Expand details",
    "l.countryName": "Country name",
    "l.eqfStatus": "EQF status",
    "l.eqfStatus.full": "Fully EQF Aligned",
    "l.eqfStatus.partial": "Partially Aligned with EQF",
    "l.eqfStatus.none": "Not Aligned with EQF",
    "l.region": "Region",
    "l.systemType": "System type",

    "validation.definition.already.exist": "There is already existing description",
    "validation.field.positive.number": "Enter a positive number",
    "validation.field.email.bad.format": "Invalid email address",
    "validation.confirmPassword.incorrect": "Passwords must match",
    "validation.username.charCount.invalid": "Invalid username. Max length: 100",
    "validation.title.ac.charCount.invalid": "Invalid name. Max length: 100",
    "validation.city.charCount.invalid": "Invalid city. Max length: 200",
    "validation.postCode.charCount.invalid": "Invalid post code. Max length: 50",
    "validation.address.charCount.invalid": "Invalid address. Max length:  500",
    "validation.phone.charCount.invalid": "Invalid phone number. Max length:  20",
    "validation.fax.charCount.invalid": "Invalid fax. Max length:  50",
    "validation.postBox.charCount.invalid": "Invalid post box. Max length:  100",
    "validation.name.charCount.invalid": "Invalid name. Max length: 200",
    "validation.number.positive.number": "Insert positive number",
    "validation.feedback.charCount.invalid": "Invalid feedback. Max length: 2000",
    "validation.attachment.file.required": "You must select a file",
    "validation.username.alreadyExists.invalid": "Username already exists",
    "validation.username.invalid": `Invalid username. ${HTML_CODES.BREAK_LINE} - characters count must be between 5 and 30 ${HTML_CODES.BREAK_LINE} - uppercase is not allowed ${HTML_CODES.BREAK_LINE} - may contain latin characters, numbers and the special symbols '.', '-' and '_' ${HTML_CODES.BREAK_LINE} - cannot start with '.', '-' and '_' ${HTML_CODES.BREAK_LINE} - cannot contain a sequence of special characters`,
    "validation.email.charCount.invalid": "Invalid email. Max length: 100",
    "validation.birthPlace.charCount.invalid": "Invalid birth place. Max length: 200",
    "validation.documentId.charCount.invalid": "Invalid document identifier. Max length: 100",
    "validation.email.alreadyExists.invalid": "Email already exists",
    "validation.password.invalid": `Invalid password. ${HTML_CODES.BREAK_LINE} - minimum length 8 ${HTML_CODES.BREAK_LINE} - at least one lower case character ${HTML_CODES.BREAK_LINE} - at least one upper case character ${HTML_CODES.BREAK_LINE} - at least one digit`,
    "validation.file.type": `Selected file type is not allowed. ${HTML_CODES.BREAK_LINE} Allowed file types: PDF and JPEG`,
    "validation.createdDate.invalid": "Enter a valid period to filter by creation date",
    "validation.sentDate.invalid": "Enter a valid period to filter by sending date",
    "validation.email.non.existing": "No user found with the specified email",
    "validation.lastUpdateDate.invalid": "Enter a valid period to filter by last update date",

    "m.home.introduction.subtitle":
      "This portal provides access to all electronic administrative services of the National Center for Information and Documentation with the ability to view documents and references.",
    "m.homePage.services":
      "List of NACID administrative services that you can request online. To access all services you need to log in to your profile.",
    "m.homePage.reports":
      "Ability to track the current status of your files. To find a file, you must have its number and access code",
    "m.homePage.law": "Documents related to complex administrative services in NACID",
    "m.homePage.registers": "List of public registers of the National Center for Information and Documentation",
    "m.homePage.registers.academicRecognition": "- academic recognition",
    "m.homePage.registers.professionalQualifications": "- professional qualifications",
    "m.delete.sitemap.group.warning.message": "Are you sure you want to delete this group?",
    "m.delete.sitemap.subgroup.warning.message": "Are you sure you want to delete this subgroup?",
    "m.delete.ac.section.warning.message": "Are you sure you want to delete this section?",
    "m.delete.ac.page.warning.message": "Are you sure you want to delete this page?",
    "m.delete.law.file.warning.message": "Are you sure you want to delete this file?",
    "m.delete.sitemap.link.warning.message": "Are you sure you want to delete this link?",
    "m.delete.email.notification.warning.message": "Are you sure you want to delete this notification?",
    "m.resend.email.notification.warning.message": "Are you sure you want to resend this notification?",
    "m.delete.email.template.warning.message": "Are you sure you want to delete this template?",
    "m.delete.email.globalMessage.warning.message": "Are you sure you want to delete this message?",
    "m.delete.service.definition.warning.message": "Are you sure you want to delete this description?",
    "m.activation.email.globalMessage.warning.message": "Are you sure you want to enable/disable this message?",
    "m.create.template.success": "Successfully saved template",
    "m.create.globalMessage.success": "Successfully saved global messages",
    "m.update.serviceDefinition.success": "Successfully edited definition",
    "m.create.serviceDefinition.success": "Successfully created definition",
    "m.feedback.submit.success": "Successfully sent feedback",
    "m.file.hint": `Allowed file formats PDF and JPEG. ${HTML_CODES.BREAK_LINE}  Max. file size: 10MB.`,
    "m.file.pdf.allowed.type.message": `Allowed file format is PDF. ${HTML_CODES.BREAK_LINE}  Max. file size: 10MB.`,
    "m.file.img.allowed.type.message": `Allowed file format is IMG. ${HTML_CODES.BREAK_LINE}  Max. file size: 10MB.`,
    "m.alert.pleaseEnterValidSearchCriteria": "Please review and fix validation errors related to search filters",
    "m.feedback.mark.read.success": "Feedback is marked as read!",
    "m.feedback.delete.read.success": "Read feedbacks are deleted!",
    "m.forgotten.password.email.success": "Email for password reset has been sent successfully!",
    "m.forgotten.username.email.success": "Email with username information has been sent successfully!",
    "m.activation.link.email.success": "Activation email has been sent successfully!",
    "m.reset.password.key.invalid": "Invalid reset password key!",
    "m.reset.password.user.invalid": "No user associated with reset password key!",
    "m.reset.password.key.expired": "Reset password key expired, please try again via the 'Forgot Password' page!",
    "m.reset.password.key.used": "The reset password key has already been used!",
    "m.reset.password.key.error": "An error occurred while verifying the reset password key!",
    "m.reset.password.success": "Password for {{user}} has been updated successfully!",
    "m.registration.success":
      "Successful registration of user profile: <b>{{username}}</b>. We have sent you activation email to <b>{{email}}</b>.",
    "m.account.activation.key.invalid": "Wrong link! Please get new activation key or send message to Administrator.",
    "m.account.activation.user.invalid":
      "There is no user connected to this activation link! Please get new activation key or send message to Administrator.",
    "m.account.activation.already.activated": "Account {{user}} has already been activated!",
    "m.account.activation.key.expired": "Expired link! Please get new activation key or send message to Administrator.",
    "m.account.activation.key.error":
      "An error occurred during activation process. Please get new activation key or send message to Administrator.",
    "m.account.activation.success": "Account {{user}} has been activated successfully!",
    "m.change.email.key.invalid": "Wrong link! Please create new change email request via the 'My Account' page!",
    "m.change.email.new.email.invalid":
      "Invalid new email ! Please create new change email request via the 'My Account' page!",
    "m.change.email.used.key": "The change email key has already been used!",
    "m.change.email.new.email.not.found":
      "New email not found ! Please create new change email request via the 'My Account' page!",
    "m.change.email.user.invalid":
      "There is no user connected to this link! Please create new change email request via the 'My Account' page!",
    "m.change.email.key.expired": "Expired link! Please create new change email request via the 'My Account' page!",
    "m.change.email.success": "Email has been successfully changed! New email: {{newEmail}}",
    "m.change.email.error":
      "An error occurred during email update process. Please create new change email request via the 'My Account' page!",
    "m.role.user.remove.confirm": "Are you sure you want to remove this user from the role?",
    "m.confirm": "Please confirm",
    "m.role.user.remove.success": "The user was successfully removed",
    "m.role.user.add.success": "The user was successfully added",
    "m.group.create.success": "The group was successfully created",
    "m.group.update.success": "The group's main details have been updated successfully",
    "m.group.delete.confirm": "Are you sure you want to delete this group?",
    "m.group.delete.success": "The group was successfully deleted",
    "m.group.user.remove.success": "The user was successfully removed",
    "m.group.role.remove.success": "The role was successfully removed",
    "m.group.user.add.success": "The user was successfully added",
    "m.group.role.add.success": "The role was successfully added",
    "m.group.user.remove.confirm": "Are you sure you want to remove the user from the group?",
    "m.group.role.remove.confirm": "Are you sure you want to remove the role from the group?",
    "m.user.main.data.update.success": "User's main data has been updated successfully !",
    "m.user.group.remove.confirm": "Are you sure you want to remove the group from the user?",
    "m.user.role.remove.confirm": "Are you sure you want to remove the role from the user?",
    "m.user.group.remove.success": "The group was successfully removed",
    "m.user.role.remove.success": "The role was successfully removed",
    "m.user.group.add.success": "The group was successfully added",
    "m.user.role.add.success": "The role was successfully added",
    "m.user.send.change.email.success": "New email address confirmation email was sent successfully",
    "m.user.change.password.success": "Password was successfully changed",
    "m.ac.section.create.success": "Section was successfully created",
    "m.ac.section.update.success": "Section was successfully updated",
    "m.ac.page.create.success": "Page was successfully created",
    "m.ac.page.update.success": "Page was successfully updated",
    "t.page.nomenclatures.reference.data": "Joined nomenclatures",
    "t.page.nomenclatures.national.university": "National universities",
    "t.page.nomenclatures.getting.result.method": "Method of getting result",
    "l.reference.data.domain": "Domain",
    "l.searchFilter.domain": "Domain",
    "l.table.head.domain": "Domain",
    "m.serviceDefinition.higherEducationRecognition": "Признаване на ОКС бакалавър и магистър, придобити в чужбина",
    "m.serviceDefinition.doctorateDegrees.doctor": "Признаване на ОНС Доктор, придобита в чужбина",
    "m.serviceDefinition.doctorateDegrees.doctorOfScience": "Признаване на НС Доктор на науките, придобит в чужбина",
    "m.serviceDefinition.uniChecks.academicStatus": "Проверка на академичния статут на чуждестранни висши училища",
    "m.serviceDefinition.uniChecks.documentAuthenticity":
      "Проверка на автентичността на документи за висше образование от чуждестранни висши училища",
    "m.serviceDefinition.uniChecks.issueRecommendation":
      "Издаване на препоръка за признаване на придобито висше образование в чуждестранни висши училища",
    "m.serviceDefinition.nonRegulatedProfessions":
      "Издаване на удостоверение за професионална квалификация по нерегулирана в България професия за други страни",
    "m.serviceDefinition.publicAccess": "Предоставяне на достъп до обществена информация",
    "m.serviceDefinition.suggestion": "Подаване на предложение",
    "m.serviceDefinition.signal": "Подаване на сигнал",
    "m.serviceDefinition.officialNotes.researchProject":
      "Издаване на служебни бележки за завършени научноизследователски проекти",
    "m.serviceDefinition.officialNotes.scientificPaper": "Издаване на служебни бележки за депозиран научен ръкопис",
    "m.serviceDefinition.officialNotes.dissertationThesis":
      "Издаване на служебни бележки за защитен дисертационен труд",
    "m.serviceDefinition.officialNotes.academicPosition": "Издаване на служебни бележки за заета академична длъжност",
    "m.serviceDefinition.inquiry.impactFactor": "Изготвяне на справки за импакт фактор на научни периодични издания",
    "m.serviceDefinition.inquiry.publicationCitings": "Изготвяне на справки за цитирания на публикации",
    "m.serviceDefinition.analyticProducts": "Изготвяне на аналитични информационни продукти",
    "m.serviceDefinition.bibliographicReferences.nacidDbs":
      "Изготвяне на библиографска справка чрез търсене в базите данни и електронните каталози на НАЦИД",
    "m.serviceDefinition.bibliographicReferences.foreignDbs":
      "Изготвяне на библиографска справка чрез достъп до чужди бази данни и други интернет ресурси",
    "m.serviceDefinition.documentDelivery.libraries":
      "Доставка на документи в печатна и електронна форма от библиотеки в страната и чужбина",
    "m.serviceDefinition.documentDelivery.nacid": "Предоставяне на копия на документи от фондове на НАЦИД",
    "m.serviceDefinition.arUniEntryRequest": "Data filing under Art.19, para.2",
    "m.middleName.required.if.exists": "Enter middle name, if the person has middle name !",
    "m.empty.contactAddress.default": "No default contact address entered",
    "m.empty.receiveResult.way.default": "No default receive result way entered",
    "m.empty.receiverAddress.default": "No default receiver address entered",
    "m.user.update.success": "User data was successfully updated",
    "m.myApplications.description":
      "Full list of created through this profile in NACID e-applications, with actual status and possibility to edit and submit those which are not yet submitted.",
    "m.myPayments.description": "History of fees and payments, possibility to pay unpaid fees online.",
    "m.myCorrespondence.description": "Electronic messages, sent by NACID through the e-services portal.",
    "m.arUniEntryRequest.description":
      "Submission of data to the register Academic recognition with decisions of higher schools for recognized diplomas in the cases under Art. 6, item 1 for the purpose of training to improve qualifications, as well as in all cases of refusal of recognition.",
    "m.arUniEntryRequest.list.description":
      "List of the data submitted through this user profile according to Art. 19, para. 2, with the possibility of editing and publishing in the register those that are in Draft status.",
    "m.search.error": "Search error. Please try again later.",

    "t.module.keycloak": "Keycloak server",
    "t.module.registers": 'Module "Registers"',
    "t.module.services": 'Module "Services"',
    "t.module.portal": 'Module "Portal"',
    "t.module.core": 'Module "Core"',

    "l.parentGroup": "Parent group",
    "t.hierarchy.details": "Group hierarchy",
    "t.inherited.roles": "Inherited roles",
    "m.portalLogin": "Login",

    "t.qualCompare.mainH.level": "Level of the National QF of ",
    "t.qualCompare.mainH.level.short": "Level - NQF",
    "t.qualCompare.mainH.subLevel": "Higher Education Degrees of the National Qualification Framework of ",
    "t.qualCompare.mainH.subLevel.short": "Degrees - NQF",
    "t.qualCompare.sideH.levelEQF": "Level according to the European Qualification Framework",
    "t.qualCompare.sideH.levelEQF.short": "Level - EQF",
    "t.qualCompare.sideH.levelBC": "Level according to the Bologna Convention",
    "t.qualCompare.sideH.levelBC.short": "Bologna Convention",
    "t.qualCompare.sideH.levelBG": "Level according to the Bulgarian Qualification Framework",
    "t.qualCompare.sideH.levelBG.short": "Level - BgQF",
    "t.qualCompare.subH.level": "Level",
    "t.qualCompare.subH.degree": "Degree",
    "t.qualCompare.subH.levelNative": "Level in the native language",
    "t.qualCompare.subH.degreeNative": "Degree in the native language",
    "t.qualCompare.subH.credits": "Credits",
    "t.qualCompare.subH.duration": "Duration",
    "t.qualCompare.mapTitle": "Map of countries",

    ...validationKeysEN.translation,
  },
});

export default messagesEn;
